import { render } from "./PeripheralConnection.vue?vue&type=template&id=2c7564aa&scoped=true&ts=true"
import script from "./PeripheralConnection.vue?vue&type=script&lang=ts"
export * from "./PeripheralConnection.vue?vue&type=script&lang=ts"

import "./PeripheralConnection.vue?vue&type=style&index=0&id=2c7564aa&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7564aa"],['__file',"src/components/PeripheralConnection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c7564aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c7564aa', __exports__)) {
    api.reload('2c7564aa', __exports__)
  }
  
  module.hot.accept("./PeripheralConnection.vue?vue&type=template&id=2c7564aa&scoped=true&ts=true", () => {
    api.rerender('2c7564aa', render)
  })

}


export default __exports__